import React from 'react';
import {makeStyles} from 'tss-react/mui';
import {FormattedMessage} from 'react-intl';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ProgressStepper from '../components/ProgressStepper';

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    textAlign: 'center',
    minHeight: '50vh',
  },
  icon: {
    fontSize: theme.typography.pxToRem(100),
    color: theme.palette.success.main,
    marginBottom: 24,
  },
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.primary,
    lineHeight: 1.6,
    maxWidth: 320,
    direction: 'ltr',
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(18),
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.success.main,
    fontWeight: 600,
    marginTop: 8,
    direction: 'ltr',
  },
}));

const SuccessScreen = () => {
  const {classes} = useStyles();

  return (
    <div>
      <ProgressStepper activeStep={3} />
      <div className={classes.container}>
        <CheckCircleOutlineIcon className={classes.icon} />
        <div className={classes.title}>
          <FormattedMessage id='docCollection.success.title' />
        </div>
        <div className={classes.subtitle}>
          <FormattedMessage id='docCollection.success.subtitle' />
        </div>
      </div>
    </div>
  );
};

export default SuccessScreen;
